export interface DistrictActionTypes {
  type: DistrictActions;
  payload?: any;
}

export enum DistrictActions {
  CREATE_DISTRICT = "CREATE_DISTRICT",
  GET_DISTRICT_LIST = "GET_DISTRICT_LIST",
  SET_DISTRICT_LIST = "SET_DISTRICT_LIST",
  SET_DISTRICT_LIST_PAGE_COUNT = "SET_DISTRICT_LIST_PAGE_COUNT",
  GET_DISTRICT_DATA_BY_ID = "GET_DISTRICT_DATA_BY_ID",
  SET_DISTRICT_DATA_BY_ID = "SET_DISTRICT_DATA_BY_ID",
  EDIT_DISTRICT_DATA_BY_ID = "EDIT_DISTRICT_DATA_BY_ID",
  DELETE_DISTRICT = "DELETE_DISTRICT"
}
